import React from 'react';
import GenericNomenclatureList from './GenericNomenclatureList';
import { useLocationTypeMutations } from '../../../hooks/useNomenclatures';

const LocationTypeList = ({ items, onUpdate }) => {
  const mutations = useLocationTypeMutations();

  const fields = [
    { name: 'level', label: 'Hierarchy Level', type: 'number' }
  ];

  return (
    <GenericNomenclatureList
      items={items}
      type="location-types"
      title="Location Types"
      fields={fields}
      mutations={mutations}
      onUpdate={onUpdate}
    />
  );
};

export default LocationTypeList;

